import { render, staticRenderFns } from "./CardSkill.vue?vue&type=template&id=4b23c420&scoped=true&"
import script from "./CardSkill.vue?vue&type=script&lang=js&"
export * from "./CardSkill.vue?vue&type=script&lang=js&"
import style0 from "./CardSkill.vue?vue&type=style&index=0&id=4b23c420&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23c420",
  null
  
)

export default component.exports